import { msg } from 'api';

export const handleLeave = (prevState, nextUrl) => {
  const urlPath = prevState.location.pathname.replace(/\/$/, '');
  const cspPaths = (msg && msg.cspUrlList) ? Object.values(msg.cspUrlList) : [];

  if (cspPaths.includes(urlPath)) {
    window.location.replace(nextUrl);
    return true; // reload required
  }

  return false; // Reload not required
};

